import { render, staticRenderFns } from "./ChoiceList.vue?vue&type=template&id=dc5dae12&"
import script from "./ChoiceList.vue?vue&type=script&lang=js&"
export * from "./ChoiceList.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceList.vue?vue&type=style&index=0&id=dc5dae12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports